/**
 * Audit Questions for Results Analyzer
 * This is the single source of truth for all audit questions
 */

export interface AuditQuestion {
  id: string;
  question: string;
  category: string;
  type?: "select";
  options?: string[];
  dependsOn?: string;
  showWhen?: string;
}

export const AUDIT_QUESTIONS: AuditQuestion[] = [
  {
    id: "audit_reviewed",
    question: "Are the results audited or reviewed?",
    category: "Both",
    type: "select",
    options: ["Audited", "Reviewed"]
  },
  {
    id: "major_events_occurred",
    question: "Any major events? like mergers, acquisitions, new share",
    category: "Both"
  },
  {
    id: "audit_report_qualified",
    question: "Qualified Audit report?",
    category: "Both",
    dependsOn: "audit_reviewed",
    showWhen: "Audited"
  },
  {
    id: "material_reclassification",
    question: "Are there any material reclassification of past results?",
    category: "Both"
  },
  {
    id: "foreign_country_components",
    question: "Are there foreign country components?",
    category: "Both"
  },
  {
    id: "goodwill_impaired",
    question: "Is goodwill impaired?",
    category: "Both"
  },
  {
    id: "associates_joint_ventures",
    question: "Does the company have associates or joint ventures?",
    category: "Both"
  },
  {
    id: "company_has_components",
    question: "Does the company have components/subsidiaries (i.e., consolidated results)?",
    category: "Both",
    type: "select",
    options: ["Yes", "No"]
  },
  {
    id: "pkf_auditor_co_reviewer",
    question: "PKF Sridhar & Santhanam LLP is the auditor or co-reviewer for another audit?",
    category: "Both",
    type: "select",
    options: ["Auditor", "Co-reviewer"]
  }
];

